import template from './acris-blog-author-detail.html.twig';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('acris-blog-author-detail', {
    template,

    inject: [
        'repositoryFactory',
        'context'
    ],

    mixins: [
        Mixin.getByName('notification'),
        Mixin.getByName('placeholder')
    ],

    data() {
        return {
            item: null,
            isLoading: false,
            processSuccess: false,
            repository: null,
            isSaveSuccessful: false
        };
    },

    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },

    computed: {
        authorRepository() {
            return this.repositoryFactory.create('acris_blog_author');
        },

        authorCriteria() {
            const criteria = new Criteria();
            // criteria.addAssociation('blogs');

            return criteria
        }
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.repository = this.repositoryFactory.create('acris_blog_author');
            this.getEntity();
        },

        getEntity() {
            this.repository.get(this.$route.params.id, Shopware.Context.api, this.authorCriteria).then((entity) => {
                this.item = entity;
            });
        },

        onClickSave() {
            this.isLoading = true;
            this.isSaveSuccessful = false;

            this.repository.save(this.item, Shopware.Context.api).then(() => {
                this.getEntity();
                this.isLoading = false;
                this.processSuccess = true;
                this.createNotificationSuccess({
                    title: this.$tc('acris-blog-author.detail.titleSaveSuccess'),
                    message: this.$tc('acris-blog-author.detail.messageSaveSuccess')
                });
            }).catch(() => {
                this.isLoading = false;
                this.createNotificationError({
                    title: this.$tc('acris-blog-author.detail.titleSaveError'),
                    message: this.$tc('acris-blog-author.detail.messageSaveError')
                });
            });
        },

        saveFinish() {
            this.processSuccess = false;
        }
    }
});

